import { ConfigurableTheme } from '../../styles/types';

export default {
  colors: {
    error: '#C82E2D',
    errorBackground: '#FCE8E8',
    errorDark: '#9f2322',

    background: '#ffffff',
    backgroundSecondary: '#ffffff',
    headerBackground: '#000000',
    headerText: '#FFFFFF',
    menuArrow: '#FFFFFF',
    modalBackdrop: 'rgba(0, 0, 0, 0.4)',

    secondary: '#000000',
    secondaryLight: 'rgba(0, 0, 0, 0.7)',
    secondarySupportLight: '#ffffff',
    secondarySupport: '#8a8a8a',

    action: '#2c2c2c',
    actionDark: '#000000',
    actionLight: '#636363',
    actionLightest: '#8e8e8e',

    actionSecondary: '#ffffff',
    actionSecondaryDark: '#fafafa',
    actionSecondaryDarker: '#f5f5f5',

    actionText: '#FFCC33',
    actionTextDark: '#d9b029',
    actionTextLight: 'rgba(255,217,102,0.81)',

    focusOutline: 'rgba(0, 0, 0, 0.2)',

    inputBackground: '#ffffff',
    inputPlaceholderFocus: 'rgba(0, 0, 0, 0.2)',
    inputSupport: 'rgba(0, 0, 0, 0.2)',

    botMessageBackground: 'rgba(0, 0, 0, 0.07)',
    userMessageBackground: '#D6D6D6',
    messageText: '#000000',

    botActionBackground: '#ffffff',
    botActionText: '#2c2c2c',
    botActionBackgroundHover: '#fafafa',
    botActionBackgroundActive: '#fafafa',

    calendarItemHover: '#FFCC33',
    calendarItemBackgroundHover: '#2c2c2c',
    calendarItemCurrent: '#858585',
    calendarItemSelected: '#FFCC33',
    calendarItemSelectedBackground: '#000000',
    calendarItemOutside: 'rgba(0, 0, 0, 0.2)',
    calendarSecondaryItem: '#000000',

    borderDark: 'rgba(0, 0, 0, .6)',
    borderMedium: 'rgba(0, 0, 0, .4)',
    borderLight: 'rgba(0, 0, 0, .18)',
  },
  fonts: {
    fontStack: '"se-motor-nouvelr"',
  },
} as ConfigurableTheme;
